import { useEffect, useState } from "react";
import "swiper/css";
import "swiper/css/navigation";

const Testimonial = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    number: "",
    message: "",
  });

  useEffect(() => {
    if (typeof window.WOW !== "undefined") {
      new window.WOW().init();
    }
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, subject, number, message } = formData;
    const mailto = `mailto:mahesht@coempt.in?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(
      `Name: ${name}\nEmail: ${email}\nPhone: ${number}\n\nMessage:\n${message}`
    )}`;
    window.location.href = mailto;
  };

  return (
    <section className="bg-image container mb-10" id="testimonial">
      <div
        className="wow fadeInLeft"
        data-wow-delay="200ms"
        data-wow-duration="1500ms"
      >
        <div className="talk-us__item">
          <div className="section-header mb-30">
            <h5 className="text-white">TALK TO US</h5>
            <h2 className="text-white">How May We Help You!</h2>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="row g-3">
              <div className="col-sm-6">
                <label htmlFor="name">Your name*</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Your name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-sm-6">
                <label htmlFor="email">Your Email*</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-sm-6">
                <label htmlFor="subject">Subject*</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  placeholder="Subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-sm-6">
                <label htmlFor="number">Your Phone*</label>
                <input
                  type="number"
                  id="number"
                  name="number"
                  placeholder="Your Phone"
                  value={formData.number}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-12">
                <label htmlFor="message">Message*</label>
                <textarea
                  id="message"
                  name="message"
                  placeholder="Write Message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <button type="submit">Send Message</button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
